var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66897 4.87447V7.92432H11.4407L10.8435 12.0327H7.66897V21.4981C7.03251 21.5864 6.38133 21.6325 5.72035 21.6325C4.95737 21.6325 4.20813 21.5717 3.4785 21.4539V12.0327H0V7.92432H3.4785V4.1927C3.4785 1.87759 5.35455 0 7.66995 0V0.00196387C7.67682 0.00196387 7.6827 0 7.68957 0H11.4417V3.5531H8.98996C8.26131 3.5531 7.66995 4.14463 7.66995 4.87349L7.66897 4.87447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.160fbf1affb766b57654764b82355273.svg";
export { ForwardRef as ReactComponent };